import { AUTH_REASON_PRIORITY } from '../../constants';
/**
 * Returns a list of {@link AuthenticationReason}s defined in the given set for the given strategy.
 */
export function getStrategyReasons(authenticationStrategies, strategy) {
    return Object.keys(authenticationStrategies)
        .map((reason) => reason)
        .filter((reason) => { var _a; return (_a = authenticationStrategies[reason]) === null || _a === void 0 ? void 0 : _a.includes(strategy); })
        .sort((a, b) => AUTH_REASON_PRIORITY[a] - AUTH_REASON_PRIORITY[b]);
}
